import Env from 'config/Env'

import { PendoInitBody } from './types/pendoTypes'

const envVar = Env.NODE_ENV

export const pendoInstance = window?.pendo

export const initializePendo = (body: PendoInitBody) => {
  if (!pendoInstance?.initialize) return
  pendoInstance.initialize({
    visitor: {
      id: body.id,
      email: body.email,
      firstName: body.firstName,
      lastName: body.lastName,
      role: body.role,
    },
    account: {
      id: body.orgId,
      orgId: body.orgId,
      organizationName: body.orgName,
    },
  })
}

export const pendoUpdateInstance = (body: PendoInitBody) => {
  if (!pendoInstance?.updateOptions) return
  pendoInstance.updateOptions({
    visitor: {
      id: body.id,
      email: body.email,
      firstName: body.firstName,
      lastName: body.lastName,
      role: body.role,
    },
    account: {
      id: body.orgId,
      orgId: body.orgId,
      organizationName: body.orgName,
    },
  })
}

export const clearPendoSession = () => {
  if (!pendoInstance.clearSession) {
    return
  }
  pendoInstance.clearSession()
}

export const getPendoVisitorId = () => {
  if (!pendoInstance.getVisitorId) {
    return ''
  }
  return pendoInstance.getVisitorId() ?? ''
}

export const isPendoEnabled = () => {
  if (envVar === 'stage' || envVar === 'production') return true
  return false
}
